// lib
import moment from "moment";
import { clone } from "ramda";
// src
import { getPresetId } from "utils/presets";
import { daysInRange } from "utils/dates";

// private
const EXPIRY_DELAY = 600000; // 10 minutes

const unfoldEventsPerSession = (events) => {
  const unfoldeds = [];
  events.forEach((event) => {
    if (event.sessions) {
      event.sessions.forEach(({ start, end }, index) => {
        const { sessions, ...withoutSessions } = event;
        unfoldeds.push({
          ...withoutSessions,
          start: moment(start).valueOf(),
          end: moment(end).valueOf(),
          private: event.visibility.id === "PRI",
          id: `${event.id}.session-${index + 1}`,
          trombinoscope: [
            {
              links: `/event/trombinoscope/${event.id}-${start}.pdf`,
            },
          ],
        });
      });
    }
  });
  return unfoldeds;
};

// API
export const filterByPresetToStore = (byPreset, dateStart, dateEnd) =>
  Object.fromEntries(
    Object.entries(byPreset).map(([id, presetLot]) => {
      const { byDay } = presetLot;
      const newByDay = Object.fromEntries(
        Object.entries(byDay).filter(([day]) => {
          const date = moment(day).valueOf();
          return date >= dateStart && date <= dateEnd;
        }),
      );
      return [id, { byDay: newByDay }];
    }),
  );

export const cleanByPreset = (byPreset) => {
  const now = Date.now();
  // prevent shallow refs to be mutated, but possibly impacts performance
  const oldByPreset = clone(byPreset);
  const newByPreset = {};

  // purge old events
  Object.entries(oldByPreset).forEach(([id, presetLot]) => {
    const { byDay } = presetLot;
    const newByDay = {};
    Object.entries(byDay).forEach(([day, dayLot]) => {
      if (now - dayLot.updatedAt < EXPIRY_DELAY) newByDay[day] = dayLot;
    });
    if (Object.keys(newByDay).length > 0) newByPreset[id] = { byDay: newByDay };
  });
  return newByPreset;
};

export const updateByPreset = (byPreset, payload) => {
  const {
    data: events,
    meta: { query },
  } = payload;
  const { dateStart, dateEnd } = query;
  const now = Date.now();
  const id = getPresetId(query);
  const newByPreset = { ...byPreset };

  // initializes for mutating output
  if (!newByPreset[id]) newByPreset[id] = { byDay: {} };
  const { byDay } = newByPreset[id]; // shortcut ref used to inject data below

  // overrides previous events per day
  daysInRange(dateStart, dateEnd).forEach((day) => {
    byDay[day] = { updatedAt: now, events: [] };
  });

  // injects events
  const processedEvents = unfoldEventsPerSession(events);
  processedEvents.forEach((e) => {
    const day = moment(e.start).format("YYYYMMDD");
    // a session may be out of range, and we do not want to start
    // filling a day *partially*
    if (byDay[day]) byDay[day].events.push(e);
  });

  return newByPreset;
};
